import React from 'react';
import {connect} from 'react-redux';
import './styles/taxDeduction.scss';

const TaxDeduction = (props) => {
    return (
      <section className="taxDeduction" id="taxDeduction">
        <div className="taxDeduction__container container">
          <div className="taxDeduction__content">
            <div className="taxDeduction__content_text-block">
              <div className="taxDeduction__content-title">
                <h2 className="section-title">Налоговый вычет</h2>
              </div>
              <p className="taxDeduction__content-text">
                  Сеть фитнес-клубов Fitron входит в перечень организаций, оказывающих физкультурно-оздоровительные услуги, по расходам на которые можно получить налоговый вычет в размере 13%.
              </p>
              <a href={props.documents?.['tax_deduction.pdf']?.url} className="btn-blue btn-blue--primary" target="_blank">Подробнее</a>
            </div>
            <div className="taxDeduction__content_image-block">
                <div className="taxDeduction__content_image-block__image"></div>
                <div className="taxDeduction__content_image-block__ellipse"></div>
            </div>
          </div>
        </div>
      </section>
    );
}

function mapStateToProps(state) {
    return {
        documents: state.documents?.documents,
    }
}
export default connect(mapStateToProps, null)(TaxDeduction);
